/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './SearchItemsDataServiceEntities.g';

function getSortedInvoicesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSortedInvoicesInput(
    invoiceSearchCriteria: Entities.InvoiceSearchCriteria,
    top: number,
    skip: number
): IDataServiceRequest {
    const query = getSortedInvoicesQuery();
    return query.createDataServiceRequestForOperation(
        'GetSortedInvoices',
        true,
        DataServiceEntities.ITSInvoiceSearchResponseExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IITSInvoiceSearchResponse'
        },
        {
            invoiceSearchCriteria: invoiceSearchCriteria,
            top: top,
            skip: skip
        }
    );
}

export function getSortedInvoicesAsync(
    context: IContext,
    invoiceSearchCriteria: Entities.InvoiceSearchCriteria,
    top: number,
    skip: number
): AsyncResult<DataServiceEntities.IITSInvoiceSearchResponse> {
    const request = getSortedInvoicesInput(invoiceSearchCriteria, top, skip);
    return callActionOrExecute<DataServiceEntities.IITSInvoiceSearchResponse>(request, context.callerContext);
}

function getStateCityQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getStateCityInput(zipCode: string): IDataServiceRequest {
    const query = getStateCityQuery();
    return query.createDataServiceRequestForOperation(
        'GetStateCity',
        false,
        DataServiceEntities.StatesEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IStatesEntity' },
        {
            zipCode: zipCode
        }
    );
}

export function getStateCityAsync(context: IContext, zipCode: string): AsyncResult<DataServiceEntities.IStatesEntity> {
    const request = getStateCityInput(zipCode);
    return callActionOrExecute<DataServiceEntities.IStatesEntity>(request, context.callerContext);
}

function getProductsByItemPartNumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductsByItemPartNumberInput(itemPartNumber: string, strictSearch: boolean): IDataServiceRequest {
    const query = getProductsByItemPartNumberQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductsByItemPartNumber',
        false,
        DataServiceEntities.ITSSearchItemPartResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSSearchItemPartResponse' },
        {
            itemPartNumber: itemPartNumber,
            StrictSearch: strictSearch
        }
    );
}

export function getProductsByItemPartNumberAsync(
    context: IContext,
    itemPartNumber: string,
    strictSearch: boolean
): AsyncResult<DataServiceEntities.IITSSearchItemPartResponse> {
    const request = getProductsByItemPartNumberInput(itemPartNumber, strictSearch);
    return callActionOrExecute<DataServiceEntities.IITSSearchItemPartResponse>(request, context.callerContext);
}

function getCustomerAddressQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerAddressInput(customerAccount: string): IDataServiceRequest {
    const query = getCustomerAddressQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerAddress',
        false,
        DataServiceEntities.ITSCustomerAddressResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSCustomerAddressResponse' },
        {
            customerAccount: customerAccount
        }
    );
}

export function getCustomerAddressAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.IITSCustomerAddressResponse> {
    const request = getCustomerAddressInput(customerAccount);
    return callActionOrExecute<DataServiceEntities.IITSCustomerAddressResponse>(request, context.callerContext);
}

function getOrderHistoryByPONumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getOrderHistoryByPONumberInput(
    queryResultSettings: IQueryResultSettings,
    pONumber: string,
    customerAccount: string,
    businessPartnerId: string
): IDataServiceRequest {
    const query = getOrderHistoryByPONumberQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetOrderHistoryByPONumber',
        false,
        EntityClasses.SalesOrderClass,
        'true',
        { bypassCache: 'get', returnEntity: 'Entities.SalesOrder' },
        {
            pONumber: pONumber,
            customerAccount: customerAccount,
            businessPartnerId: businessPartnerId
        }
    );
}

export function getOrderHistoryByPONumberAsync(
    context: IContext,
    pONumber: string,
    customerAccount: string,
    businessPartnerId: string
): AsyncResult<Entities.SalesOrder[]> {
    const request = getOrderHistoryByPONumberInput(context.queryResultSettings || {}, pONumber, customerAccount, businessPartnerId);
    return callActionOrExecute<Entities.SalesOrder[]>(request, context.callerContext);
}

function simplePingPostQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingPostInput(): IDataServiceRequest {
    const query = simplePingPostQuery();
    return query.createDataServiceRequestForOperation('SimplePingPost', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingPostAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingPostInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function simplePingGetQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingGetInput(): IDataServiceRequest {
    const query = simplePingGetQuery();
    return query.createDataServiceRequestForOperation('SimplePingGet', false, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingGetAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingGetInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function boundControllerQuery(unusualEntityId?: number): DataServiceQuery {
    const key = unusualEntityId ? { UnusualEntityId: unusualEntityId } : null;
    return new DataServiceQuery('BoundController', 'ExampleEntity', DataServiceEntities.ExampleEntityExtensionClass, key);
}

export function createCreateExampleEntityInput(entityData: DataServiceEntities.IExampleEntity): IDataServiceRequest {
    const query = boundControllerQuery();
    return query.createDataServiceRequestForOperation(
        'CreateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { entityData: entityData }
    );
}

export function createExampleEntityAsync(context: IContext, entityData: DataServiceEntities.IExampleEntity): AsyncResult<number> {
    const request = createCreateExampleEntityInput(entityData);
    return callActionOrExecute<number>(request, context.callerContext);
}

export function createUpdateExampleEntityInput(
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'UpdateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { updatedEntity: updatedEntity }
    );
}

export function updateExampleEntityAsync(
    context: IContext,
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): AsyncResult<boolean> {
    const request = createUpdateExampleEntityInput(unusualEntityId, updatedEntity);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createDeleteExampleEntityInput(unusualEntityId: number): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'DeleteExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {}
    );
}

export function deleteExampleEntityAsync(context: IContext, unusualEntityId: number): AsyncResult<boolean> {
    const request = createDeleteExampleEntityInput(unusualEntityId);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createGetAllExampleEntitiesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = boundControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllExampleEntities',
        false,
        DataServiceEntities.ExampleEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IExampleEntity' },
        {}
    );
}

export function getAllExampleEntitiesAsync(context: IContext): AsyncResult<DataServiceEntities.IExampleEntity[]> {
    const request = createGetAllExampleEntitiesInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IExampleEntity[]>(request, context.callerContext);
}
